import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useQuery } from '@apollo/react-hooks'
import { examsPropertiesQueries } from '../../graphql/queries'
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

const useStyles = makeStyles((theme) => ({
    institutionFieldControlDesk: {
        minWidth: 320,
        marginRight: 24
    },
    yearFieldControlDesk: {
        minWidth: 80
    },
    fieldControlMD: {
        width: '100%'
    },
    headerText: {
        fontSize: '1.25rem'
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const SelectFieldsBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px
`

const SelectTestFieldsBlock = styled.div`
    margin-top: 48px;
    display: flex;
    flex-direction: column
`

const FiltrosProva = () => {
    const classes = useStyles();
    const deskBreakpoint = useMediaQuery('(min-width:1050px)')
    const [institution, setInstitution] = useState()
    const [year, setYear] = useState([])
    const [yearOptions, setYearOptions] = useState([])
    const [result, setResult] = useState([])
    const [displayResults, setDisplayResults] = useState(false)
    const [exam, setExam] = useState('none')

    const { data } = useQuery(examsPropertiesQueries.GET_INSTITUTIONS)

    const { data: examData } = useQuery(examsPropertiesQueries.GET_EXAMS)

    const getExamId = (event) => {
        setExam(event.target.value)
    }

    const getYears = (institutionValue) => {
        let institutionsFound = ((examData || {}).provas || []).filter(item => (item.instituicao._id === institutionValue))
        setYearOptions(institutionsFound.map(item => (item.ano)))
    }


    const getExams = (institutionValue, yearValue) => {
        let avaiableExams = ((examData || {}).provas || []).filter(item => ((item.ano === yearValue) && (item.instituicao._id === institutionValue)))
        setResult(avaiableExams)
    }

    const verifyDuplicatedItems = (years) => {
        
        let newYears = []
        for (const item of years) {
            if (newYears.indexOf(item) === -1) {
                newYears.push(item)
            }
        }

        return newYears.sort().reverse()
    }

    useEffect(() => {
        getYears(institution)
    }, [institution]) // eslint-disable-line

    useEffect(() => {
        getExams(institution, year);
        setDisplayResults(true)
    }, [year]) // eslint-disable-line

    useEffect(() => {
        setDisplayResults(false)
    }, [])

    return (<>
        <Typography gutterBottom variant="body1" component="p" className={classes.headerText}>
            Procure provas ultilizando os filtros abaixo:
        </Typography>
        <SelectFieldsBlock>
            <FormControl variant="outlined" className={deskBreakpoint ? classes.institutionFieldControlDesk : classes.fieldControlMD}>
                <InputLabel id="demo-simple-select-outlined-label">Instituição</InputLabel>
                <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={institution}
                    onChange={(e) => setInstitution(e.target.value)}
                    label="Instituição"
                >
                    {((data || {}).instituicoes || []).map((item, key) => (<MenuItem value={item._id}>{item.nome}</MenuItem>))}
                </Select>
            </FormControl>
            {(yearOptions !== '') ?
                <FormControl variant="outlined" className={deskBreakpoint ? classes.yearFieldControlDesk : classes.fieldControlMD}>
                    <InputLabel id="demo-simple-select-outlined-label">Ano</InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        label="Ano"
                        disabled={year === (undefined || [])}
                    >
                        {verifyDuplicatedItems(yearOptions || []).map((item, key) => (<MenuItem value={item}>{item}</MenuItem>))}
                    </Select>
                </FormControl>
                : null
            }
        </SelectFieldsBlock>
        {displayResults && <SelectTestFieldsBlock>
            <FormControl component="fieldset">
                <FormLabel gutterBottom variant="body1" color="black" component="p">Provas encontradas:</FormLabel>
                <RadioGroup aria-label="exams" name="examsOptions" value={exam} onChange={getExamId}>
                    {(result || []).map((item, key) => <FormControlLabel value={item._id} control={<Radio />} label={`${item.instituicao.nome} ${item.descricao || ''} - Ano: ${item.ano}`} />)}
                </RadioGroup>
            </FormControl>
            <Link className={classes.menuLink}>
                <Button disabled={exam === 'none'} component={RouterLink} to={`/prova/${exam || {}}`} variant="contained" color="primary" style={{ width: 'auto' }} endIcon={<ArrowForwardIosIcon style={{ fontSize: '16px' }} />}>Iniciar</Button>
            </Link>
        </SelectTestFieldsBlock>}
    </>)
}

export default FiltrosProva